import React from 'react';

import classes from './sectionComercio.module.css';
import { NavLink } from 'react-router-dom';
const sectionComercio = () => {
  return (
    <div className={classes.moduleCommerce}>
      <div className="icons-header space-top-title">
        <img src="images/marquer.svg" className="icons-main" alt="icons main" />
      </div>
      <div>
        <h1 className="main-text space-top-commerce">Siempre hay un Comercio Claro Pay cerca de ti.</h1>
        <p className="desc-text text-body" style={{ maxWidth: '100%', paddingBottom: '2rem' }}>
          Los Comercios Claro Pay son lugares donde puedes agregar o retirar dinero, e incluso pagar
          usando tu app Claro Pay. Sin importar dónde estés, siempre podrás encontrar los comercios que necesitas
          en la sección "Cerca de mí" de la aplicación y así aprovechar todos los descuentos y promociones
          que Claro Pay tiene para ti.
        </p>
        <NavLink to="/comercios" className="btn-red a-btn-red-lignt"> Descubre los Comercios Claro Pay </NavLink>
      </div>
    </div>
  )
}

export default sectionComercio;

